<template>
    <nav aria-label="Page navigation" v-show="paginationData > 0">
        <div class="d-flex justify-content-around flex-wrap flex-md-row flex-column align-items-center">
            <!-- Sección de Total Records -->
            <div class="p-2 text-center">
                Total Records {{ totalRecords }}
            </div>

            <!-- Sección de Paginación -->
            <div class="p-2">
                <ul class="pagination justify-content-center">
                    <!-- Selector de Página -->
                    <li class="page-item">
                        <select id="page-select" class="form-control" v-model.number="selectedPage" @change="jumpToPage">
                            <option v-for="page in totalPagesArray" :key="page" :value="page">
                                {{ page }}
                            </option>
                        </select>
                    </li>
                    <!-- Botón de Página Anterior -->
                    <li class="page-item" :class="{ disabled: isPrevDisabled }">
                        <a class="page-link" @click="prevPage" >
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </a>
                    </li>
                    <!-- Páginas visibles -->
                    <li class="page-item" v-for="page in visiblePages" :key="page"
                        :class="{ 'active': currentPage === page }">
                        <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                    </li>
                    <!-- Botón de Página Siguiente -->
                    <li class="page-item" :class="{ disabled: isNextDisabled }">
                        <a class="page-link" @click="nextPage" >
                            <i class="fa fa-chevron-right" aria-hidden="true"></i>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Sección de Displayed Records -->
            <div class="p-2 text-center">
                Displayed from {{ from }} to {{ to }}
            </div>
        </div>
    </nav>
</template>

<script setup lang="ts">
    import { ref, computed } from 'vue';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    prevPage: () => void;
    nextPage: () => void;
    goToPage: (page: number) => void;
    visiblePages: number[];
    paginationData: number;
    totalRecords: number;
    from: number;
    to: number;
}

    const props = defineProps<PaginationProps>();
    const isPrevDisabled = computed(() => props.currentPage <= 1);
    const isNextDisabled = computed(() => props.currentPage >= props.totalPages);


    const selectedPage = ref(props.currentPage);

    const prevPage = () => {
        if (!isPrevDisabled.value) props.prevPage();
    };

    const nextPage = () => {
        if (!isNextDisabled.value) props.nextPage();
    };

    // Crear un array con todas las páginas para el menú desplegable
    const totalPagesArray = computed(() => {
        return Array.from({ length: props.totalPages }, (_, i) => i + 1);
    });

    const jumpToPage = () => {
        if (selectedPage.value >= 1 && selectedPage.value <= props.totalPages) {
            props.goToPage(selectedPage.value);
        } else {
            alert(`Por favor, ingrese un número de página válido entre 1 y ${props.totalPages}`);
        }
    };
</script>